import { z } from "zod"
import { MembershipFormTranslations } from "./use-translations"

const ResourceAbilitySchema = z.object({
  resourceId: z.string(),
  abilities: z.array(z.string()),
})

const isValidEmail = (email?: string) => {
  if (!email || email.trim().length <= 0) return false
  return z.string().email().safeParse(email).success
}

const requireName = (data: { firstname?: string; lastname?: string }) => {
  return Boolean(data.firstname?.trim() || data.lastname?.trim())
}

const requireEmailIfInviting = ({ userEmail, sendInvitation }: { userEmail?: string; sendInvitation: boolean }) => {
  if (!sendInvitation) return true
  return isValidEmail(userEmail)
}

export const createMembershipFormDataSchema = ({ translations }: { translations: MembershipFormTranslations }) => {
  return z
    .object({
      firstname: z.string().optional(),
      lastname: z.string().optional(),
      userEmail: z.string().optional(),
      sendInvitation: z.boolean(),
      abilitiesToAdd: z.array(z.string()),
      abilitiesToRemove: z.array(z.string()),
      associations: z.array(z.string()),
      abilitiesInResources: z.array(ResourceAbilitySchema),
      copyPermissionsFrom: z.string().optional(),
      language: z.string(),
    })
    .refine(requireName, {
      message: translations.firstnameRequiredText,
      path: ["firstname"],
    })
    .refine(requireEmailIfInviting, {
      message: translations.provideValidEmailToInvite,
      path: ["userEmail"],
    })
}
